module.exports = __webpack_public_path__ + "img/hr-curved-rail-horizontal-right-top-ties-remnants.3f69d287.png";